module.exports = __webpack_public_path__ + "img/conversation.8a414e5f.png";